import { render, staticRenderFns } from "./MakeAnEntryNutrition.vue?vue&type=template&id=01a19c2a&lang=pug&"
import script from "./MakeAnEntryNutrition.vue?vue&type=script&lang=js&"
export * from "./MakeAnEntryNutrition.vue?vue&type=script&lang=js&"
import style0 from "./MakeAnEntryNutrition.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports